// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import {
  ParagraphComponent,
  TitleComponent,
  WizardStepperComponent,
} from '@openbank/ziniaweb-ui-components';
import { LayoutOperationalAssetComponent } from './components/asset/layout-operational-asset.component';
// Constants
import {
  LAYOUT_COMPONENT_PARAGRAPH_PROPS,
  LAYOUT_COMPONENT_TITLE_PROPS,
} from './constants/layout-operational.constants';
// Contexts
import { useStylesContextConsumerHook } from 'contexts/styles.context';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Styles
import {
  LayoutOperationalComponentStyled,
  LayoutOperationalBottomSideComponentStyled,
  LayoutOperationalMaxWidthComponentStyled,
} from './layout-operational.component.styled';
// Types
import { LayoutOperationalType } from './types/layout-operational.type';
// Translations
import { LAYOUT_STEP_TITLES, STEP_PROGRESS } from './translations/layout-operational.translations';
// Utils
import { getProgressBarPercentage } from './utils/layout-operational.utils';

const LayoutOperationalComponent = ({
  assetId,
  children,
  currentState,
  currentStep,
  description,
  maxSteps,
  renderChildren,
  title,
  values,
}: LayoutOperationalType): React.JSX.Element | React.ReactNode => {
  const { paddingContent } = useStylesContextConsumerHook();

  return renderChildren ? (
    <LayoutOperationalComponentStyled>
      <LayoutOperationalMaxWidthComponentStyled {...{ paddingContent }}>
        <WizardStepperComponent
          progressBars={{
            percentProgressCompleted: getProgressBarPercentage({ currentStep, maxSteps }),
          }}
          textProgress={<FormattedMessage id={STEP_PROGRESS} values={{ currentStep, maxSteps }} />}
          title={<FormattedMessage id={LAYOUT_STEP_TITLES[currentState as AppStatesEnumeration]} />}
        />
      </LayoutOperationalMaxWidthComponentStyled>
      <LayoutOperationalBottomSideComponentStyled {...{ hasTitle: title }}>
        {title && (
          <TitleComponent
            {...LAYOUT_COMPONENT_TITLE_PROPS}
            title={<FormattedMessage id={title} values={values} />}
          />
        )}
        <LayoutOperationalAssetComponent {...{ assetId }} />
        {description && (
          <ParagraphComponent {...LAYOUT_COMPONENT_PARAGRAPH_PROPS}>
            <FormattedMessage id={description} values={values} />
          </ParagraphComponent>
        )}
        <>{children}</>
      </LayoutOperationalBottomSideComponentStyled>
    </LayoutOperationalComponentStyled>
  ) : null;
};

export { LayoutOperationalComponent };
